import { productInfo, assemblySteps } from "@/mocks/product";

export default function StorySection() {
  return (
    <section id="story" className="w-full bg-white py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="order-2 lg:order-1">
              <span className="text-xs font-medium text-stone-400 tracking-widest uppercase">
                Our Story
              </span>

              <h2
                className="mt-6 text-3xl md:text-4xl font-semibold text-stone-900 leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Where Wine Culture
                <br />
                <span className="font-light text-stone-500">Meets Cat Life</span>
              </h2>

              <p className="mt-8 text-base md:text-lg text-stone-600 leading-relaxed">
                {productInfo.description}
              </p>

              <p className="mt-4 text-base md:text-lg text-stone-600 leading-relaxed">
                The graceful silhouette of a classic wine bottle, reimagined as a scratching post your cat will love. Natural jute rope wraps the entire post for satisfying scratching, while the sturdy wood base keeps it grounded — even during the most enthusiastic play sessions.
              </p>

              <a
                href="#features"
                className="inline-block mt-8 text-sm font-medium text-stone-900 underline underline-offset-4 decoration-stone-300 hover:decoration-stone-900 transition-colors"
              >
                Explore the Details
              </a>

              <div className="mt-10 flex gap-12">
                <div>
                  <p className="text-3xl md:text-4xl font-bold text-stone-900">
                    {productInfo.dimensions.height}
                  </p>
                  <p className="mt-1 text-xs text-stone-400 tracking-wide">
                    Height
                  </p>
                </div>
                <div>
                  <p className="text-3xl md:text-4xl font-bold text-stone-900">
                    {productInfo.dimensions.width}
                  </p>
                  <p className="mt-1 text-xs text-stone-400 tracking-wide">
                    Base Width
                  </p>
                </div>
                <div>
                  <p className="text-3xl md:text-4xl font-bold text-stone-900">
                    3
                  </p>
                  <p className="mt-1 text-xs text-stone-400 tracking-wide">
                    Easy Steps
                  </p>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden">
                  <img
                    src={productInfo.images.detail2}
                    alt="Product detail"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -left-6 md:-bottom-8 md:-left-8 w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden border-4 border-white">
                  <img
                    src={productInfo.images.detail3}
                    alt="Product detail"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Assembly Steps */}
          <div className="mt-24 md:mt-32">
            <div className="text-center mb-12 md:mb-16">
              <span className="text-xs font-medium text-stone-400 tracking-widest uppercase">
                Simple Setup
              </span>
              <h2
                className="mt-4 text-2xl md:text-4xl font-semibold text-stone-900"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Assembled in 3 Steps
              </h2>
              <p className="mt-2 text-sm md:text-base text-stone-500">
                Everything you need is in the box. No extra tools required.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {assemblySteps.map((step) => (
                <div
                  key={step.step}
                  className="relative bg-[#faf9f7] rounded-2xl p-8 md:p-10 text-center"
                >
                  <div className="w-12 h-12 mx-auto mb-6 rounded-full bg-stone-900 text-white flex items-center justify-center text-lg font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-lg font-semibold text-stone-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-stone-500 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}